import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {goTo, toPriceStr} from '@/utils';
import {InviteRechargeRule} from '../../agent.type';
import {ReactComponent as QuestionIcon} from '../../assets/question.svg';
import AspectRatio from '@/components/basic/aspect-ratio';

const inviteNewGetBg = require('@/pages/agent/assets/invite-new-get-bg.webp');

interface InvitationRewardCardProps {
  rewardRules: InviteRechargeRule[];
  onShare: () => void;
  onQuestionClick?: () => void;
  code?: string;
}

const InvitationRewardCard: React.FC<InvitationRewardCardProps> = ({
  rewardRules,
  onShare,
  onQuestionClick,
  code,
}) => {
  const {t} = useTranslation();

  // 获取最高奖励金额
  const maxRewardAmount = useMemo(() => {
    if (!rewardRules || rewardRules.length === 0) {
      return 0;
    }
    return Math.max(...rewardRules.map(rule => rule.rewardAmount));
  }, [rewardRules]);

  return (
    <AspectRatio className="w-full rounded-xl" ratio={351 / 185}>
      <div
        className="relative size-full bg-full"
        style={{
          backgroundImage: `url(${inviteNewGetBg})`,
        }}>
        <div className="overflow-clip relative rounded-[inherit] size-full">
          {/* 问号按钮 */}
          <div
            className="absolute content-stretch cursor-pointer flex items-center justify-center right-4 top-4 overflow-visible p-0 size-4"
            onClick={onQuestionClick || (() => goTo('InvitationRule'))}>
            <QuestionIcon className="size-4 text-[#9e5a17]" />
          </div>

          {/* 主标题 */}
          <p className="absolute font-medium leading-normal left-1/2 -translate-x-1/2 not-italic text-[#9e5a17] text-sm text-nowrap top-4 whitespace-pre">
            {t('agent.invitation-reward.inviteNewCustomersGet')}
          </p>

          {/* 奖励金额 */}
          <p className="absolute font-din font-bold leading-normal left-1/2 -translate-x-1/2 not-italic text-[#6e350f] text-nowrap top-[2.8rem] text-[2.4375rem] whitespace-pre">
            {toPriceStr(maxRewardAmount, {fixed: 0})}
          </p>

          {/* 分享按钮 */}
          <div className="absolute left-1/2 -translate-x-1/2 top-[6.5rem] w-[18.1875rem] h-12">
            <button
              className="box-border content-stretch flex gap-1 h-12 items-center justify-center px-6 py-3 rounded-lg w-full"
              style={{
                backgroundImage:
                  'linear-gradient(rgb(255, 238, 194) 0%, rgb(255, 117, 17) 52.348%, rgb(255, 179, 28) 92.59%), linear-gradient(rgb(240, 222, 130) 0%, rgba(180, 125, 45, 0.824) 98%), linear-gradient(rgb(214, 170, 83) 12.166%, rgb(124, 68, 26) 100%)',
              }}
              onClick={onShare}>
              <p className="font-medium leading-none not-italic relative shrink-0 text-[#51320b] text-base text-center text-nowrap uppercase whitespace-pre">
                {t('agent.myTeam.inviteFriends').toUpperCase()}
              </p>
            </button>
          </div>

          {/* 邀请码文案 */}
          <div className="absolute left-1/2 -translate-x-1/2 top-[10rem] text-center w-full">
            <p className="text-[#51320B] text-xs font-bold">
              {t('agent.invitation-reward.myInvitationCode')}{' '}
              <span className="text-t1">{code || '--------'}</span>
            </p>
          </div>
        </div>

        {/* 阴影效果 */}
        <div className="absolute inset-0 pointer-events-none shadow-[0_2px_0_0_inset_rgba(255,255,255,0.1)]" />
      </div>
    </AspectRatio>
  );
};

export default InvitationRewardCard;
